<div class="modal-header orange-bg">
  <h5 class="text-center uppercase cut"
      [translate]="'modal.resetBasket.header'">
    Er du sikker?
  </h5>

  <i class="icon-close" (click)="modal.close({cleanCart: false, cancel: true})"></i>
</div>
<div class="modal-body"
     [innerHTML]="'modal.resetBasket.message' | translate">
  Du kan bare bestille fra et bakeri per bestilling. Om du endrer sted blir handlekurven slettet.
</div>
<div class="modal-footer d-md-flex d-none">
  <button class="btn btn-pink me-3"
          (click)="modal.close({cleanCart: true, cancel: false})"
          [translate]="'modal.resetBasket.button.resetLong'">
    Bytt sted
  </button>
  <button class="btn btn-outline-pink"
          (click)="modal.close({cleanCart: false, cancel: true})"
          [translate]="'modal.resetBasket.button.cancelLong'">
    Avbryte
  </button>
</div>
<div class="modal-footer d-flex d-md-none">
  <button class="btn btn-pink me-3"
          (click)="modal.close({cleanCart: true, cancel: false})"
          [translate]="'modal.resetBasket.button.reset'">
    Bytt sted
  </button>
  <button class="btn btn-outline-pink"
          (click)="modal.close({cleanCart: false, cancel: true})"
          [translate]="'modal.resetBasket.button.cancel'">
    Avbryte
  </button>
</div>
